import moment from 'moment'
import {
    WALLET_BRL_BALANCE_ERROR,
    WALLET_BRL_BALANCE_LOAD,
    WALLET_BRL_BALANCE_SUCCESS,
    WALLET_BRL_CASHIN_ERROR,
    WALLET_BRL_CASHIN_SUBMIT,
    WALLET_BRL_CASHIN_SUCCESS,
    WALLET_BRL_CASHOUT_ERROR,
    WALLET_BRL_CASHOUT_SUBMIT,
    WALLET_BRL_CASHOUT_SUCCESS,
    WALLET_BRL_CASHIN_FILE
} from '../actionTypes'
import { request, API_URL, getInfoLocalStorage } from '../../utils/api'
import { loginExpired } from './wallet'
import { fetchUserInfo } from './users'
import { loadBalance } from './wallet_btc'

export const brlBalanceLoad = () => ({
    type: WALLET_BRL_BALANCE_LOAD
})

export const brlBalanceError = (message = 'Houve um erro ao carregar seu saldo') => ({
    type: WALLET_BRL_BALANCE_ERROR,
    payload: {
        message
    }
})

export const brlBalanceSuccess = (balance) => ({
    type: WALLET_BRL_BALANCE_SUCCESS,
    payload: {
        balance
    }
})

export const loadBrlBalance = (id) => async dispatch => {
    try {
        dispatch(brlBalanceLoad())
        const { code, message, balance } = await request(`wallet/brl-balance/${id}`)
        if (code === 51) {
            dispatch(brlBalanceSuccess(balance))
        }
        else {
            dispatch(brlBalanceError(message))
        }
    } catch(e) {
        dispatch(brlBalanceError())
    }
}

export const getCashIn = (comprovante, userid) => async dispatch => {
    if(comprovante === null) {
        dispatch(cashInFile())
    } else {
        dispatch(cashInSubmit())
        const formData = new FormData()
        formData.append("file", comprovante)
        formData.append("userid", userid)
        const req = await fetch(API_URL + 'wallet/cash-in', {
            method: 'POST',
            body: formData,
            headers: {
                'Authorization': `Bearer ${getInfoLocalStorage().token}`
            }
        })
        const response = await req.json()
        if(response.code === 81) {
            dispatch(cashInSuccess())
        } else {
            dispatch(cashInError())
        }
    }
}

export const cashInError = (message = 'Houve um erro ao salvar suas informações. Por favor, envie o compravente para um de nossos atendentes.') => ({
    type: WALLET_BRL_CASHIN_ERROR,
    payload: {
        message
    }
})

export const cashInSubmit = () => ({
    type: WALLET_BRL_CASHIN_SUBMIT
})

export const cashInFile = () => ({
    type: WALLET_BRL_CASHIN_FILE
})

export const cashInSuccess = (message = 'Depósito recebido!') => ({
    type: WALLET_BRL_CASHIN_SUCCESS,
    payload: {
        message
    }
})

export const getCashOut = (value, tabAtiva, form, userid) => async dispatch => {
    if(moment().isSameOrAfter(getInfoLocalStorage().userExpiration)){
        dispatch(loginExpired())
    } else {
        if(value != 0) {
            if(value < 2000) {
                dispatch(cashOutError('O valor de transferência deve ser superior a R$20,00', 'size'))
            } else {
                form.validateFieldsAndScroll(async (err, values) => {
                    if(!err){
                        try{
                            dispatch(cashOutSubmit())
                            var strValue = String(value)
                            var decimalValue = strValue.substring(0,strValue.length-2)+"."+strValue.substring(strValue.length-2);
                            let banco = values.bankCode
                            let codigoBanco = String(parseInt(banco, 10))
                            if(codigoBanco.length === 2) {
                                codigoBanco = '0'+codigoBanco
                            }
                            let length = values.account.length
                            let accountDigit = values.account[length-1]
                            let fullAccount = values.account.slice(0, -1)
                            fullAccount = fullAccount.replace('-', '')
                            let document = values.document.replace('.', '')
                            document = document.replace('-', '')
                            document = document.replace('.', '')
                            document = document.replace('/', '')
                            const { code, message, id, error } = await request('wallet/cash-out', "POST", {
                                userid,
                                banco: values.bankCode,
                                accountType: values.accountType,
                                bankCode: String(codigoBanco),
                                account: fullAccount,
                                accountDigit: accountDigit,
                                name: values.name,
                                document: document,
                                type: document.length === 11 ? 'CPF' : 'CNPJ',
                                amount: decimalValue,
                                password: values.password,
                                favorite: tabAtiva,
                                branch: values.branch
                            })
                            dispatch(fetchUserInfo(userid))
                            if(code === 61) {
                                dispatch(cashOutSuccess())
                                window.location.replace(`/wallet/transacao?id=${id}&type=5&status=CONFIRMED`)
                                
                            } else {
                                dispatch(cashOutError(message, error))
                            }
                        } catch(e) {
                            console.log(e)
                            dispatch(cashOutError(e))
                        }
                    } 
                })
            }
            
        } else {
            dispatch(cashOutError('Insira um valor', 'value'))
        }
    }
}

export const cashOutSuccess = (message = 'Transferência realizada!') => ({
    type: WALLET_BRL_CASHOUT_SUCCESS,
    payload: {
        message
    }
})

export const cashOutError = (message, error) => ({
    type: WALLET_BRL_CASHOUT_ERROR,
    payload: {
        message,
        error
    }
})

export const cashOutSubmit = () => ({
    type: WALLET_BRL_CASHOUT_SUBMIT
})